
<fieldset>
  <legend>
    <slot></slot>
  </legend>

  <row :class="additionalClass">
    <column :size="fullWidth ? '100%' : '50%'" v-if="typeOptions.length !== 1">
      <div class="sr-only">
        <label :for="prop_key + '_type'" class="a-select-label">{{displayName}} Type</label>
      </div>
      <a-select
        v-model="value.type"
        :options="typeOptions"
        :disabled="typeOptions.length===1"
        :compress="compress"
        :id="prop_key + '_type'"
        :name="prop_key + '_type'"></a-select>
    </column>
    <div v-if="propertyForSection(DurationType.propertyBasedTimeSpan, 'includeWindowComparisonOptions') && value.type == DurationType.propertyBasedTimeSpan">
      <div class="sr-only">
        <label :for="prop_key + '_window_comparison_type'" class="a-select-label">{{displayName}} Window Comparison Type</label>
      </div>
      <a-select
        v-model="value.window_comparison_type"
        :options="windowComparisonOptions"
        :compress="compress"
        :id="prop_key + '_unit'"
        :name="prop_key + '_unit'"></a-select>
    </div>

    <column :size="fullWidth ? '100%' : '50%'">
      <template v-if="value.type === DurationType.customFormula">
        <formula-wrapper
          field-name="derived_value"
          :dynamic-options="dynamicOptions"
        >
          <template #value="slotProps">
            <expandable-textarea
              :key="slotProps.model[slotProps.fieldName]"
              v-model="slotProps.model[slotProps.fieldName]"
              id="formulaValue"
              type="text"
              placeholder="Enter a formula"
              is-multiline
            ></expandable-textarea>
          </template>
        </formula-wrapper>
      </template>
      <template
        v-if="value.type === DurationType.timespan || value.type === DurationType.fixedDateAfterTimeSpan ||  value.type == DurationType.propertyBasedTimeSpan">
        <multi-input full :compress="compress">
          <column>
            <div class="sr-only">
              <label :for="prop_key + '_amount'" class="a-select-label">{{displayName}} Amount</label>
            </div>
            <number-input
              v-model="value.amount"
              :replacement-value="0"
              :id="prop_key + '_amount'"
              :name="prop_key + '_amount'"
            ></number-input>
          </column>
          <column>
            <div class="sr-only">
              <label :for="prop_key + '_unit'" class="a-select-label">{{displayName}} Unit</label>
            </div>
            <a-select
              v-model="value.unit"
              :options="unitOptions"
              :compress="compress"
              :id="prop_key + '_unit'"
              :name="prop_key + '_unit'"></a-select>
          </column>
        </multi-input>
      </template>

      <template
        v-if="value.type === DurationType.fixedDate || value.type === DurationType.fixedDateAfterTimeSpan">
        <div class="sr-only">
          <label :for="prop_key + '_month'" class="a-select-label">{{displayName}} Month</label>
        </div>
        <multi-input full :compress="compress">
          <column>
            <div class="sr-only">
              <label :for="prop_key + '_day'" class="a-select-label">{{displayName}} Day</label>
            </div>
            <a-select
              v-model="value.day"
              :options="numDays"
              :id="prop_key + '_day'"
              :name="prop_key + '_day'"></a-select>
          </column>
          <column>
            <a-select
              v-model="value.month"
              :options="DurationAndTimeHelper.monthOptions"
              :id="prop_key + '_month'"
              :name="prop_key + '_month'"></a-select>
          </column>
        </multi-input>
      </template>
    </column>
    <template  v-if="value.type == DurationType.propertyBasedTimeSpan">
    <column :size="fullWidth ? '100%' : '50%'" >
        <div class="sr-only">
          <label :for="prop_key + '_comparison'" class="a-select-label">Period Start Relative Date Comparison</label>
        </div>
        <a-select
          :compress="compress"
          v-model="value.comparison"
          :options="statusActivationDateComparisonVOptions"
          :id="prop_key + '_comparison'"
        ></a-select>
      </column>

      <column :size="fullWidth ? '100%' : '50%'" class="flex-wrap min-max">
        <template v-if="value.type === DurationType.propertyBasedTimeSpan">
          <label v-if="propertyForSection(DurationType.propertyBasedTimeSpan, 'sectionLabel')" :for="prop_key + '_property'">{{propertyForSection(DurationType.propertyBasedTimeSpan, 'sectionLabel') || 'Period Start Relative Date Property' }}</label>
          <div v-else class="sr-only">
            <label :for="prop_key + '_property'" class="a-select-label">{{propertyForSection(DurationType.propertyBasedTimeSpan, 'sectionLabel') || 'Period Start Relative Date Property' }}</label>
          </div>
          <a-select
            :compress="compress"
            v-model="propertyValue"
            bind-by-object
            :options="propertyForSection(DurationType.propertyBasedTimeSpan, 'dropdownOptions')"
            :id="prop_key + '_property'"
          />
        </template>

      </column>
    </template>
    <template  v-if="value.type === DurationType.datePicker">
      <date-picker
        v-model="value.datetime"
        :compress="compress"
        :mode="DatetimeMode.Date"
      >
      </date-picker>
    </template>
  </row>


</fieldset>
